export default {
  properties: {
    modified: {
      properties: {
        $gte: {
          calc: {
            func: 'null',
            when: '!this.$gte'
          },
          format: 'date',
          title: 'Wydane od',
          type: 'string'
        },

        $lte: {
          calc: {
            func: 'null',
            when: '!this.$lte'
          },
          format: 'date',
          title: 'Wydane do',
          type: 'string'
        }
      },
      type: 'object'
    },

    isUkraine: {
      default: null,
      title: 'Wniosek UA',
      type: 'boolean'
    }
  },
  type: 'object'
};
